<template>
  <v-dialog v-model="dialog" width="600px" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
      <v-card-title class="white--text primary"
        >SỬA LỚP HỌC {{ classData.title }}
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-divider></v-divider>
      <v-form ref="form" flat class="pa-6">
        <v-row>
          <v-col cols="12" md="6" class="pb-0">
            <AutocompleteSubject
              v-model="subject"
              label="Môn học"
              return-object
              placeholder="Chọn môn học"
              outlined
              dense
              class="required"
              :filter="filterSubject"
              :rules="[$rules.required]"
              @change="subjectChanged"
            />
          </v-col>
          <v-col cols="12" md="6" class="pb-0">
            <AutocompleteGrade :disabled="disabled" v-model="grade" label="Khối" dense outlined />
          </v-col>
          <v-col cols="12" md="12" class="py-0">
            <v-text-field
              ref="title"
              v-model="title"
              label="Tên lớp"
              outlined
              required
              dense
              class="required"
              :rules="[$rules.required]"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" class="pt-0">
            <v-textarea ref="description" v-model="description" label="Mô Tả" hide-details outlined />
          </v-col>
        </v-row>
      </v-form>
      <v-divider></v-divider>

      <v-card-actions>
        <v-btn class="px-6 mx-2" outlined light depressed @click="cancel">Hủy</v-btn>
        <v-spacer></v-spacer>
        <v-btn class="px-6 mx-2" depressed color="primary" @click="save">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { get, chunk } from 'lodash'
import AutocompleteGrade from '@/components/basic/input/AutocompleteGrade'
import AutocompleteSubject from '@/components/basic/input/AutocompleteSubject'
import { Teaching } from '@/plugins/api'

export default {
  components: {
    AutocompleteGrade,
    AutocompleteSubject
  },
  props: {
    state: Boolean,
    classData: Object,
    slots: Array
  },
  data() {
    return {
      dialog: false,
      loading: false,
      description: '',
      title: '',
      division: null,
      grade: null,
      subject: null,
      disabled: false
    }
  },

  computed: {
    filterSubject() {
      return { type: 'extraCurriculum' }
    }
  },
  methods: {
    ...mapActions('classDetail', ['updateClass', 'updateTeaching']),
    async save() {
      if (!this.$refs.form.validate()) return
      this.$loading.active = true

      //   const classesFilter = await Class.fetch({ id_ne: this.classData.id })
      //   if (classesFilter.find(c => c.title === this.title)) {
      //     this.$alert.error('Tên lớp đã tồn tại')
      //     this.$loading.active = false
      //     return
      //   }

      try {
        const data = {
          title: this.title,
          grade: get(this.grade, 'id'),
          extraSubject: get(this.subject, 'id'),
          description: this.description
        }

        if (this.classData.extraSubject.id !== data.extraSubject) {
          // sửa môn thì tạo lại giảng dạy
          const teachings = await Teaching.fetch({
            class: this.classData.id
          })

          const groups = chunk(teachings, 5)
          for (let subTeachings of groups) {
            await Promise.all(
              subTeachings.map(async t => {
                return Teaching.remove(t.id)
              })
            )
          }
          const classData = await this.updateClass({ id: this.classData.id, ...data })
          await Teaching.create({
            class: classData.id,
            grade: data.grade,
            subject: classData.extraSubject.id,
            subjectGroup: get(classData.extraSubject, 'subjectGroup.id')
          })
        } else {
          if (this.classData.grade.id !== data.grade) {
            // cập nhật khối, cập nhật giảng dạy
            const teachings = await Teaching.fetch({
              class: this.classData.id
            })

            const groups = chunk(teachings, 5)
            for (let subTeachings of groups) {
              await Promise.all(
                subTeachings.map(async t => {
                  return this.updateTeaching({ id: t.id, grade: data.grade })
                })
              )
            }
          }

          await this.updateClass({ id: this.classData.id, ...data })
        }

        this.dialog = false
        this.$alert.updateSuccess()
      } catch (error) {
        console.error(error)
        this.$alert.updateError()
      } finally {
      }
      this.$loading.active = false
    },
    subjectChanged(subject) {
      const grade = get(subject, 'grade')
      if (grade && grade.id) {
        this.disabled = true
      } else {
        this.disabled = false
      }
      this.grade = grade
    },
    cancel() {
      this.dialog = false
    }
  },
  watch: {
    state(state) {
      this.dialog = true
      if (this.classData && this.classData.id) {
        this.grade = this.classData.grade
        this.subject = this.classData.extraSubject
        this.title = this.classData.title
        this.description = this.classData.description
        if (get(this.subject, 'grade')) {
          this.disabled = true
        } else {
          this.disabled = false
        }
      }
    }
  }
}
</script>
